import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Landing/Navbar";
import Footer from "./Components/Landing/Footer";
import Home from "./Pages/Home/Home";
import PrivacyPolicy from "./Pages/Privacy/PrivacyPolicy";
import RefundPolicy from "./Pages/Refund/RefundPolicy";
import TermsOfServices from "./Pages/Terms/TermsOfServices";

// Scroll to the top on page change, or to the #section in the URL.
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollManager />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<div className="pt-20"><TermsOfServices /></div>} />
        <Route path="/refund-policy" element={<div className="pt-20"><RefundPolicy /></div>} />
        <Route path="/privacy" element={<div className="pt-20"><PrivacyPolicy /></div>} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
